import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-hide-text-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'hide-text-button.component.html',
})
export class HideTextButtonComponent {
  // @ts-expect-error
  @Input() showInvisButton: boolean;
  @Output() toggle: EventEmitter<boolean> = new EventEmitter();

  handleToggle(e: any) {
    this.toggle.emit(!this.showInvisButton);
    return false;
  }

  constructor() {}
}
